import type { BranchRepresentationType } from '@readme/api/src/mappings/branch/types';
import type { VersionRepresentationType } from '@readme/api/src/mappings/version/types';

/**
 * For an argument that is either a `BranchRepresentationType` or
 * `VersionRepresentationType`, narrows the type of that argument to
 * `VersionRepresentationType` if it is detected to be a version shape.
 */
export function isVersion(
  versionOrBranch?: BranchRepresentationType | VersionRepresentationType | null,
): versionOrBranch is VersionRepresentationType {
  if (!versionOrBranch) return false;
  /**
   * @todo API v2 branch representation type once it's ready may have a better
   * property than `release_stage` to discriminate on (e.g. `type: 'version' | 'branch'`)
   * @link https://linear.app/readme-io/issue/RM-12359/create-branch-mapper-version-mapper-updates
   */
  return 'release_stage' in versionOrBranch;
}

/**
 * For an argument that is either a `BranchRepresentationType` or
 * `VersionRepresentationType`, narrows the type of that argument to
 * `BranchRepresentationType` if it is detected to be a branch shape.
 */
export function isBranch(
  versionOrBranch?: BranchRepresentationType | VersionRepresentationType | null,
): versionOrBranch is BranchRepresentationType {
  if (!versionOrBranch) return false;
  return !isVersion(versionOrBranch);
}
